import React, { useState } from "react";
import PropTypes from "prop-types";
import CommonMenuEntries from "./CommonMenuEntries";
import RoleMenuEntries from "./RoleMenuEntries";
import ActivityCount from "./ActivityCount";

const AccountMenu = ({ role, user }) => {
  const [menuVisible, setMenuVisible] = useState(false);

  const topbarDropdownClassNames = ["topbar-account-nav", "topbar-dropdown", "topbar-module"];

  if (menuVisible) {
    topbarDropdownClassNames.push("open");
  }

  return (
    // TODO: rework this dom structure, may need style changes.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <nav className={topbarDropdownClassNames.join(" ")} onClick={() => setMenuVisible(!menuVisible)}>
      <ActivityCount value={user.newsFeedCount} />

      <div className="menu-button-contents">
        <span className="menu-button-text">
          <span className="menu-button-name">{user.name}</span>
          <i className="icon-caret-down drop-down-caret" />
        </span>
        <img width="170" height="170" alt="" src={user.avatar} />
      </div>

      <ul className="menu">
        <RoleMenuEntries role={role} />
        <CommonMenuEntries user={user} />
      </ul>
    </nav>
  );
};

AccountMenu.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    newsFeedCount: PropTypes.number.isRequired,
  }).isRequired,
  role: PropTypes.string.isRequired,
};

export default AccountMenu;
